import _ from "lodash";

export const TWENTY_EIGHT_UNITS = 28;

export const MONTHLY_FREQUENCY_OPTIONS = [
  { label: "1 mes", value: 30 },
  { label: "2 meses", value: 60 },
  { label: "3 meses", value: 90 },
];

/**
 * Same labels as the monthly options: the doctor picks "1 mes" and we repeat every 28 days so the
 * next prescription matches the pack (Natan, web-client#282: the doctor doesn't need to know).
 */
export const TWENTY_EIGHT_DAY_FREQUENCY_OPTIONS = [
  { label: "1 mes", value: 28 },
  { label: "2 meses", value: 56 },
  { label: "3 meses", value: 84 },
];

/**
 * Indexes every vademecum presentation's pack units by its regNo.
 * @param {Array} vademecum medicines as served by GET /medications/file
 * @returns {Object<string, number>} units by regNo, only for presentations that have them
 */
export const unitsByRegNo = (vademecum) =>
  _(vademecum)
    .flatMap("presentaciones")
    .filter((presentation) => _.isNumber(presentation?.units))
    .keyBy("regNo")
    .mapValues("units")
    .value();

/**
 * Recurring frequency options: 28-day multiples when any selected medicine comes in a 28-unit pack,
 * calendar months otherwise.
 * @param {Array} medicines selected medicines (with the presentation regNo as externalId)
 * @param {Object<string, number>} presentationUnits units by regNo (see unitsByRegNo)
 */
export const recurringFrequencyOptions = (medicines, presentationUnits) => {
  const hasTwentyEightUnitPack = _.some(
    medicines,
    (medicine) => presentationUnits[medicine?.externalId] === TWENTY_EIGHT_UNITS
  );
  return hasTwentyEightUnitPack ? TWENTY_EIGHT_DAY_FREQUENCY_OPTIONS : MONTHLY_FREQUENCY_OPTIONS;
};

/**
 * The option in the same position of the other frequency list (30 <-> 28 days, 60 <-> 56, 90 <-> 84), so a doctor's choice survives the list switching when medicines change.
 * @param {number} selectedDays current recurring.days
 * @param {Array} options frequency options now on screen
 * @returns {number|null} the equivalent value, or null when selectedDays is not in either list
 */
export const equivalentFrequency = (selectedDays, options) => {
  const position = _.findIndex(
    _.includes(_.map(MONTHLY_FREQUENCY_OPTIONS, "value"), selectedDays)
      ? MONTHLY_FREQUENCY_OPTIONS
      : TWENTY_EIGHT_DAY_FREQUENCY_OPTIONS,
    { value: selectedDays }
  );
  return _.get(options, [position, "value"], null);
};
